import { getBRCurrencyFormat } from '@app/utils/formmater';
import React, { ChangeEvent, Ref, useRef } from 'react';
import classes from './styles.module.css';
import formsClasses from '@app/styles/forms.module.css';
import { Checkbox, CheckboxProps, FormControlLabel, makeStyles } from '@material-ui/core';
import cls from 'classnames';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { Colors } from '@app/config/colors';
import CurrencyInput from '@app/components/CurrencyInput';
import formClasses from '@app/styles/forms.module.css';

type Props = {
  value: number | null;
  onValueChange: (newChangeValue: number | null) => void;
  isNeedOfChange: boolean;
  onChangeIsNeedOfChange: (isNecessary: boolean) => void;
  changeErrorMessage?: string;
  inputRef?: Ref<HTMLInputElement>;
  onInputFocus?: (containerRef: HTMLElement | null) => void;
  inputClassName?: string;
};

export default function ChangeInput({
  value,
  onValueChange,
  isNeedOfChange,
  onChangeIsNeedOfChange,
  changeErrorMessage,
  inputRef,
  onInputFocus,
  inputClassName,
}: Props) {
  const { primaryColor } = useRestaurantContext();

  const containerRef = useRef<HTMLDivElement>(null);

  function handleCheckboxChange(_: ChangeEvent<HTMLInputElement>, checked: boolean) {
    onChangeIsNeedOfChange(!checked);
  }

  function handleFocus() {
    onInputFocus && onInputFocus(containerRef.current);
  }

  return (
    <div className={classes.container} ref={containerRef}>
      <span className={classes.title} style={{ color: primaryColor || Colors.DefaultPrimaryColor }}>
        Troco para
      </span>
      {isNeedOfChange && (
        <>
          <CurrencyInput
            ref={inputRef}
            value={value}
            onNumberValueChange={onValueChange}
            placeholder="R$ 0,00"
            className={cls(formsClasses.textField, classes.input, inputClassName && inputClassName)}
            style={{ height: 40 }}
            onFocus={handleFocus}
          />
          {Boolean(changeErrorMessage) && (
            <span className={formClasses.errorMessage} style={{ marginTop: 5 }}>
              {changeErrorMessage}
            </span>
          )}
        </>
      )}
      <FormControlLabel
        control={
          <Checkbox
            checked={!isNeedOfChange}
            onChange={handleCheckboxChange}
            style={{ color: !isNeedOfChange ? primaryColor || Colors.DefaultPrimaryColor : undefined }}
          />
        }
        label={<span className={classes.checkboxLabel}>Não precisa de troco</span>}
      />
    </div>
  );
}
